import { useState, type FormEvent } from "react";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da21oljk8r5te5mqsdq0";

export default function Newsletter() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    const honeypot = (data.get("website_alt") as string | null) ?? "";
    if (honeypot.trim()) {
      setStatus("success");
      setMessage("订阅成功，感谢关注小秘漫画网！");
      form.reset();
      return;
    }

    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key === "website_alt") return;
      payload.append(key, value as string);
    });

    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: { code?: string; meta?: { message?: string; detail?: string }; message?: string } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const isSpam =
        serverMsg.toLowerCase().includes("spam") ||
        responseText.toLowerCase().includes("form data is spam");

      if (res.ok && parsed?.code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功，编辑部的好书推荐会定期发到你邮箱。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "订阅失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络开小差了，请稍后再试。");
    }
  }

  return (
    <section id="订阅" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <div className="overflow-hidden rounded-lg bg-gradient-to-br from-primary-100 via-background-100 to-secondary-100">
          <div className="grid items-center gap-10 p-8 md:p-12 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-mail-star-line" aria-hidden="true"></i>
                小秘周刊
              </span>
              <h2 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
                每周精选，直接送到你邮箱
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
                订阅「小秘周刊」，每周一封：编辑推荐、严选冷门与热荐榜单，一次看懂本周值得读的漫画。随时可退订。
              </p>
            </div>

            <form
              id="newsletter-form"
              data-readdy-form="小秘漫画网订阅表单"
              onSubmit={handleSubmit}
              className="flex flex-col gap-3"
            >
              <div className="flex flex-col gap-3 sm:flex-row">
                <label htmlFor="newsletter-email" className="sr-only">
                  邮箱地址
                </label>
                <input
                  id="newsletter-email"
                  type="email"
                  name="email"
                  required
                  placeholder="输入你的邮箱地址"
                  autoComplete="email"
                  className="w-full rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none"
                />
                <button
                  type="submit"
                  className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  立即订阅
                </button>
              </div>
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              {status === "success" && (
                <p className="flex items-center gap-2 text-sm font-medium text-accent-700">
                  <i className="ri-checkbox-circle-line" aria-hidden="true"></i>
                  {message}
                </p>
              )}
              {status === "error" && (
                <p className="flex items-center gap-2 text-sm font-medium text-primary-700">
                  <i className="ri-error-warning-line" aria-hidden="true"></i>
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}